import type { IconName } from "@similarweb/icons";

import { abbrNumberVisitsFilter, decimalNumberFilter, percentageSignFilter, timeFilter } from "app/filters/ngFilters";

export type MetricKey = "visits" | "growth" | "pagesPerVisit" | "visitDuration" | "bounceRate";

export type FormatterFunction = (value: number) => string;

type MetricConfiguration = {
    metricName: string;
    iconName: IconName;
    dataKey: string;
    valueFormatter: FormatterFunction;
    precision?: number;
};

export const METRIC_CONFIGURATION: Record<MetricKey, MetricConfiguration> = {
    visits: {
        metricName: "industry.analysis.geo.tab.visits",
        iconName: "month",
        dataKey: "Visits",
        valueFormatter: abbrNumberVisitsFilter(),
        precision: 1,
    },
    growth: {
        metricName: "industry.analysis.geo.tab.growth",
        iconName: "trend-up",
        dataKey: "Growth",
        valueFormatter: percentageSignFilter(),
        precision: 2,
    },
    pagesPerVisit: {
        metricName: "industry.analysis.geo.tab.ppv",
        iconName: "pages-per-visit",
        dataKey: "PagesPerVisit",
        valueFormatter: (value: number) => decimalNumberFilter()(value, false),
        precision: 2,
    },
    visitDuration: {
        metricName: "industry.analysis.geo.tab.timepervisit",
        iconName: "avg-visit-duration",
        dataKey: "TimePerVisit",
        valueFormatter: (value: number) => timeFilter()(value, null) as string,
    },
    bounceRate: {
        metricName: "industry.analysis.geo.tab.bouncerate",
        iconName: "bounce-rate-2",
        dataKey: "BounceRate",
        valueFormatter: (value: number) => decimalNumberFilter()(value, false),
        precision: 2,
    },
};

export const METRIC_KEYS = Object.keys(METRIC_CONFIGURATION) as MetricKey[];

// Helper functions for easier access
export const getMetricConfig = (metric: MetricKey): MetricConfiguration => METRIC_CONFIGURATION[metric];

const getAllMetricConfigs = (): MetricConfiguration[] => METRIC_KEYS.map((key) => METRIC_CONFIGURATION[key]);
